// @flow
import type {
  FieldBorderOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<FieldBorderOperation>,
})
